import { Trash2, ImageIcon } from "lucide-react";
import { resolveMediaUrl } from "../../../lib/api";

export const VideoListItem = ({ v, idx, uploadingThumbFor, onThumbnailUpload, onRemove }) => (
  <div className="flex items-center justify-between border rounded px-4 py-2" data-testid={`admin-video-item-${idx}`}>
    <div className="flex items-center gap-3">
      {v.thumbnail ? (
        <img src={resolveMediaUrl(v.thumbnail)} alt="Portada" className="h-12 w-20 object-cover rounded" data-testid={`admin-video-thumbnail-preview-${idx}`} />
      ) : (
        <div className="h-12 w-20 flex items-center justify-center bg-secondary rounded text-muted-foreground">
          <ImageIcon size={16} />
        </div>
      )}
      <div>
        <p className="text-sm font-medium">
          {v.title || "Sin título"} {v.type === "file" && <span className="text-xs text-muted-foreground">(archivo subido)</span>}
        </p>
        <p className="text-xs text-muted-foreground break-all">{v.url}</p>
      </div>
    </div>
    <div className="flex items-center gap-3 shrink-0">
      <label data-testid={`admin-video-thumbnail-label-${idx}`} className="flex items-center gap-1 border rounded px-2 py-1.5 text-xs cursor-pointer hover:bg-secondary/50">
        <ImageIcon size={14} /> {uploadingThumbFor === idx ? "Subiendo..." : "Portada"}
        <input
          data-testid={`admin-video-thumbnail-input-${idx}`}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={onThumbnailUpload}
          disabled={uploadingThumbFor === idx}
        />
      </label>
      <button data-testid={`admin-video-remove-${idx}`} onClick={onRemove}>
        <Trash2 size={16} />
      </button>
    </div>
  </div>
);
